import type { Role } from '@/shared/types';

/** The slice of the logged-in user a role gate needs. */
export type RoleGateUser = {
  roles?: string[] | null;
  isSuperuser?: boolean | null;
};

/**
 * True when the user holds at least one of `anyOf`.
 *
 * Mirrors the backend `RolesGuard`: a superuser short-circuits every role
 * check, so a gate here can never end up stricter than the endpoint behind it.
 * Roles are compared as backend role KEYS (`admin`, `data_analyst`) — that is
 * what login returns (`login.dto.ts` maps `roles.map((r) => r.key)`).
 */
export const isAllowedByRoles = (
  user: RoleGateUser | null | undefined,
  anyOf: Role[],
): boolean => {
  if (!user) return false;
  if (user.isSuperuser) return true;
  if (anyOf.length === 0) return true;

  const held = new Set(user.roles ?? []);
  return anyOf.some((role) => held.has(role));
};
